/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Shadow_Size_AriaInputs */



/**
* | output |
* | --- |
* | "Shadow Size" |
*
* @param {Video_Export_Shadow_Size_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_shadow_size_aria = /** @type {((inputs?: Video_Export_Shadow_Size_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Shadow_Size_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille de l'ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schattengröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione dell'ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер тени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de la sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阴影大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("影のサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छाया का आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da sombra")
	return /** @type {LocalizedString} */ ("Shadow Size")
});